import React from 'react';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import useConversionEmailHarvester from '../hooks/useConversionEmailHarvester';
import styles from './ConversionEmailHarvesterCard.module.scss';
import Stars from './assets/yellow-stars.svg';
import ArrowRight from './assets/arrow.svg';

export interface IConversionEmailHarvesterCard {
  className?: string;
  insploreTopic?: string;
  boardId?: string | number;
  useAlternateLayout?: boolean;
}

/**
 * all your inbox are belong to us!
 */
export default function ConversionEmailHarvesterCard({
  className,
  insploreTopic,
  boardId,
  useAlternateLayout = false
}: IConversionEmailHarvesterCard) {
  const theme = useTheme();
  const {
    email,
    submitted,
    setEmail,
    onSubmit
  } = useConversionEmailHarvester({
    insploreTopic,
    boardId,
  });

  return (
    <div className={`${styles.CTACard} ${className || ''}`}>
      <div className={classnames(styles.Contents, {
        [styles.ContentsAlt]: useAlternateLayout
      })}
      >
        {
          !useAlternateLayout ? (
            <div className={classnames(
              theme.styles.Title2,
              styles.PrimaryText
            )}
            >
              Stay up to date with the latest design trends &nbsp;
              <Stars />
            </div>
          ) : (
            <>
              <Stars className={styles.Stars} />
              <div className={classnames(
                theme.styles.Title2,
                styles.PrimaryText,
                styles.Alt
              )}
              >
                Stay up to date with the latest design trends &nbsp;
              </div>
            </>
          )
        }

        {!submitted ? (
          <form
            className={ styles.Form }
          >
            <input
              className={ styles.EmailInput }
              placeholder="Enter your email here"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="submit"
              className={ styles.IconButton }
              aria-label="Submit"
              onClick={onSubmit}
              disabled={ !email }
            >
              <ArrowRight />
            </button>

          </form>
        ) : (
          <p className={ styles.ThankYou }>Success! Thanks for subscribing.</p>
        )}
      </div>
    </div>
  );
}
